import React from 'react';
import { Route, Switch } from 'react-router';
import Layout from 'components/Layout';
import List from './List';
import Form from './Form';

const Post = () => (
  <Layout>
    <Switch>
      <Route exact path="/posts" component={List} />
      <Route exact path="/posts/new" component={Form} />
      <Route exact path="/posts/:id" component={Form} />
    </Switch>
  </Layout>
);

export default Post;
